
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/makeup-recommendations/blush-placement",
      function () {
        return require("private-next-pages/makeup-recommendations/blush-placement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/makeup-recommendations/blush-placement"])
      });
    }
  